import { Edit, SimpleForm, TextInput } from "react-admin";

const EditPullApartMapping = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm>
        <TextInput label="SQR Make" source="sqrMake" fullWidth required />
        <TextInput label="SQR Model" source="sqrModel" fullWidth required />
        <TextInput
          label="Pull-A-Part Make"
          source="papMake"
          fullWidth
          required
        />
        <TextInput
          label="Pull-A-Part Model"
          source="papModel"
          fullWidth
          required
        />
      </SimpleForm>
    </Edit>
  );
};

export default EditPullApartMapping;
